import styled from '@emotion/styled';
import { Modal } from '@mui/material';

export const BaseModalContainer = styled(Modal)`

  
`;
